import * as React from 'react';
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router';
import UpdateAvailableFlag from '../../components/pwa-helper-components/UpdateAvailableFlag';
import { AppContextProvider, useAppContext } from '../../context/app-context';

const AuthenticatedApp = React.lazy(
  () => import('./components/AuthenticatedApp'),
);
const UnauthenticatedApp = React.lazy(() => import('../SignIn/SignIn'));

function RequireAuth() {
  const [appState] = useAppContext();
  if (!appState?.user) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function App() {
  const router = createBrowserRouter([
    {
      path: 'login',
      element: (
        <React.Suspense fallback="Loading...">
          <UnauthenticatedApp />
        </React.Suspense>
      ),
    },
    {
      path: '*',
      element: <RequireAuth />,
      children: [
        {
          path: '*',
          element: (
            <React.Suspense fallback="Loading...">
              <AuthenticatedApp />
            </React.Suspense>
          ),
        },
      ],
    },
  ]);

  return (
    <AppContextProvider>
      <RouterProvider router={router} />
      <UpdateAvailableFlag />
    </AppContextProvider>
  );
}

export default App;
